import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58b778d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "top",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.backToTop && _ctx.backToTop(...args)))
  }, [
    _createElementVNode("img", {
      src: _ctx.top,
      alt: ""
    }, null, 8, _hoisted_1)
  ]))
}